import App from "../App.svelte";
import {mount} from "svelte";

export type MetaContext = {
    version: string;
    gameBundleHref: string;
    staticRoot: string;
    env: "dev" | "prod";
}

declare global {
    interface Window {
        initializeApp: () => void;
        metaContext: MetaContext;
    }
}

function mountSvelteApp() {
    // @ts-ignore
    mount(App, {
        target: document.body,
    });
}

window.initializeApp = function() {
    console.log("initializeApp()");
    mountSvelteApp();
}

window.initializeApp();
